import type { ReactNode } from 'react'

interface LegalSectionProps {
  children: ReactNode
}

/**
 * Seção branca full-width para conteúdo legal/institucional.
 *
 * Substitui o card arredondado anterior: em vez de um cartão solto sobre
 * fundo escuro, o conteúdo ocupa toda a largura com fundo branco, e o
 * texto é contido em um container para leitura confortável.
 *
 * Tipografia usa `prose` do Tailwind Typography com ajustes para overflow
 * (break-words, overflow-wrap) e hierarquia de headings adequada.
 */
export function LegalSection({ children }: LegalSectionProps) {
  return (
    <section className="w-full bg-white py-12 sm:py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="prose prose-slate max-w-none prose-headings:font-display prose-headings:text-brand-dark prose-h1:text-2xl prose-h1:sm:text-3xl prose-h2:text-xl prose-h2:sm:text-2xl prose-p:leading-relaxed prose-a:text-primary prose-a:no-underline hover:prose-a:underline [&_*]:break-words [&_*]:[overflow-wrap:anywhere]">
          {children}
        </div>
      </div>
    </section>
  )
}
